import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Chip, Button } from "@mui/material";

const ChipDialog = ({ open, onClose, name, mappedData = [] }) => {
  return (
    <Dialog open={open} onClose={onClose} className="dialogBoxModal_viewAll" key={name}>
      <DialogTitle>{`${name} (${mappedData.length})`}</DialogTitle>
      <DialogContent sx={{ maxHeight: "300px", overflowY: "auto" }}>
        {mappedData.length > 0 ? (
          mappedData.map((option, index) => (
            <Chip
              key={index}
              label={option}
              sx={{
                margin: "4px",
                whiteSpace: "normal",
                wordBreak: "break-word",
                maxWidth: "100%",
                display: "inline-block",
                height: "auto",
                padding: "10px",
                ".MuiChip-label": { whiteSpace: "normal !important" },
              }}
            />
          ))
        ) : (
          <p>No items selected</p>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: "black",
            color: "white",
            textTransform: "capitalize",
            height: "30px",
            maxWidth: "90px",
            width: "100%",
            borderRadius: "6px",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.2)",
            "&:hover": {
              backgroundColor: "black",
              boxShadow: "0px 2px 8px rgba(0,0,0,0.5)",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChipDialog;
